import { render, staticRenderFns } from "./commissionStatistics.vue?vue&type=template&id=70c889ba&scoped=true"
import script from "./commissionStatistics.vue?vue&type=script&lang=js"
export * from "./commissionStatistics.vue?vue&type=script&lang=js"
import style0 from "./commissionStatistics.vue?vue&type=style&index=0&id=70c889ba&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c889ba",
  null
  
)

export default component.exports